import { Box, Divider, Text } from "@mantine/core";

export default function ListHeader({ title, mt = 0 }) {
  return (
    <Box mt={mt}>
      <Text size="xs" fw={700}>
        {title}
      </Text>
      <Divider color="dark" size="sm" mb="sm" />
    </Box>
  );
}
